export type NatureOfBusinessTypes = 'broker' | 'vendor' | 'supplier' | 'dealer' | 'financebroker' |null;

export type NatureOfBusinessValue = NatureOfBusinessTypes;
